import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export const PracticeIntegration = () => (
  <section className="bg-ivory py-28 lg:py-36 border-t border-navy/10" data-testid="practice-integration-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">
            In-House Capability, Without the Overhead
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-navy leading-tight">
            Bring specialist cardiac diagnostics directly to your practice.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <blockquote className="mt-10 border-l-2 border-gold pl-6">
            <p className="font-serif italic text-xl lg:text-2xl text-navy/80 leading-snug">
              “Your patients. Your clinical environment. Specialist cardiac diagnostics
              delivered by CVI.”
            </p>
          </blockquote>
          <Link
            to="/contact"
            data-testid="practice-integration-cta"
            className="mt-10 inline-block bg-navy text-ivory font-mono text-[11px] tracking-[0.2em] uppercase px-8 py-4 hover:bg-gold hover:text-navy transition-colors"
          >
            Discuss a Diagnostic Service
          </Link>
        </Reveal>
      </div>

      <div className="lg:col-span-7 space-y-8">
        {[
          "Expand your cardiac diagnostic capability without building an in-house service. CVI provides flexible, fully supported diagnostic sessions delivered within your own clinical environment — bringing the specialist expertise, advanced diagnostic equipment and established clinical processes that integrate seamlessly with your existing patient pathway.",
          "From echocardiogram and 12-lead ECG to Holter monitoring from 24 hours up to 28 days and beat-to-beat ambulatory blood pressure, every service is tailored to the needs of private practices, primary care providers and healthcare organisations.",
          "Whether you require a regular diagnostic clinic, additional capacity, or a flexible session-based service, CVI enables you to offer patients convenient access to specialist cardiac diagnostics — closer to home, and within a familiar clinical setting.",
        ].map((text, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="flex gap-6">
              <span className="font-mono text-xs tracking-[0.3em] text-gold shrink-0 pt-1.5">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-base text-navy/60 leading-relaxed">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
